import {cssTheme} from '@logistics-frontend/blocks/theme'
import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const mainButtonContainer = css`
  padding-inline: ${spacing(2, 2)};
  margin-block-end: ${spacing(2)};
`

export const mainButton = css`
  inline-size: 100%;
`

export const imgContainer = css`
  block-size: ${spacing(25)};
  inline-size: 100%;
  position: relative;
  overflow: hidden;
`

export const img = css`
  inline-size: 100%;
  block-size: 100%;
  object-fit: contain;
`

export const root = css`
  background-color: ${cssTheme.default.day.background};
`

export const modalHead = css`
  inline-size: 100%;
`

export const titleContainer = css`
  padding-inline: ${spacing(2, 2)};
  padding-block: ${spacing(0, 1.5)};
`

export const bodyContainer = css`
  padding-inline: ${spacing(2, 2)};
  padding-block: ${spacing(0, 2)};
`

export const bodyText = css`
  gap: ${spacing(1.25)};
  display: inline;
`

export const controlContainer = css`
  padding-block: ${spacing(0, 1)};
`

export const controlButtonContainer = css`
  padding-inline: ${spacing(1, 1)};
  padding-block: ${spacing(0.5, 0)};
`

export const controlButton = css`
  inline-size: 100%;
`

export const zIndexDraver = css`
  z-index: 960;
`
